import React from 'react'

import { Row, Button } from 'components'
import { SPACING } from 'utils'

export interface ButtonsRow {
  resetPage: () => void
  handleVisualizar: () => void
  disableImprimir: boolean
}
const ButtonsRow: React.FC<ButtonsRow> = ({
  resetPage,
  handleVisualizar,
  disableImprimir
}) => {
  return (
    <Row alignItems="center" justifyContent="end" marginTop={SPACING.spacing30}>
      <Button
        text="Limpar"
        variantButton="text"
        onClick={resetPage}
        marginRight={SPACING.spacing15}
      />
      {!disableImprimir && (
        <Button
          text="Imprimir"
          variantButton="outlined"
          marginRight={SPACING.spacing15}
          marginLeft={SPACING.spacing15}
        />
      )}
      <Button text="Visualizar" onClick={handleVisualizar} />
    </Row>
  )
}

export default ButtonsRow
